// cleaner task status

import { serviceTypes } from './serviceTypes';
import { GEOGRAPHICAL_MAP } from './Map';
import { SITE_POLICY_DEFAULT_VALUES } from './visitor';
import { TASK_STATUS } from './task';

export const CLEANER_OPERATIONAL_TASK_DEFAULT_FILTERS = {
  archived: false,
  businessClient: undefined,
  site: undefined,
  taskType: serviceTypes.cleaning,
};

export const TASK_CLEANING_DEFAULT = {
  isTemplate: false,
  wrapsId: null,
  scanCode: null,
  scanAutoStart: null,
  scanStartOnly: null,
  surfaceViewPreferred: true,
  status: TASK_STATUS.NEW.id,
  taskName: '',
  siteSurfaceImages: GEOGRAPHICAL_MAP,
  newBusinessClient: false,
  severityRating: 'NOT_RATED',
  ...SITE_POLICY_DEFAULT_VALUES,
};

export const SUBTASK_CLEANING_DEFAULT = {
  isTemplate: false,
  wrapsId: null,
  scanCode: null,
  scanAutoStart: null,
  scanStartOnly: null,
  surfaceViewPreferred: true,
  status: TASK_STATUS.NEW.id,
  siteSurfaceImages: GEOGRAPHICAL_MAP,
};
